import { Theme } from '@mui/material/styles';

import { deepNavy } from '../../palette-v2';

// ----------------------------------------------------------------------
// V2 Design System — Tooltip
//
// The v1 override painted tooltips with `grey[800]` (#424242). Under v2, GREY is
// the standard MUI ramp, which made this the one visible neutral in the app that
// isn't part of the deepNavy family.
// ----------------------------------------------------------------------

export function tooltipV2(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: deepNavy[900],
          color: deepNavy[50],
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(0.75, 1.5),
          fontSize: theme.typography.caption.fontSize,
          fontWeight: theme.typography.fontWeightRegular,
          lineHeight: theme.typography.caption.lineHeight,
          letterSpacing: theme.typography.caption.letterSpacing,
        },
        arrow: {
          color: deepNavy[900],
        },
      },
    },
  };
}
